const cedula = localStorage.getItem('doc')

export const conveniosRecaudo = [
  {item: "Convenio", value: 92573},
  {item: "Referencia", value: cedula },
]

export const conveniosEfecty = [
  {item: "Convenio", value: 25056},
  {item: "Referencia", value: cedula },
]

export const conveniosWU = [
  {item: "Convenio financiero", value: "Galilea"},
  {item: "Referencia", value: cedula },
]

export const conveniosRecaudoExtend = [
  {item: "Convenio", value: 15045},
  {item: "Referencia", value: cedula },
]